import React, { useMemo, useState } from "react";
import { useSelector } from "react-redux";

import {
    reportsSection,
    reportsLayout,
    reportsMenu,
    reportMenuButton,
    reportMenuButtonActive,
    reportsContent,
} from "./admin-panel.module.scss";
import { mainGrid } from "../../../styles/grid.module.scss";
import { selectUserProfile } from "../../../redux/user/user.selectors";

import Section from "../../../components/molecules/section";
import ReportNewUserAndSurvey from "../molecules/report-new-user-and-survey";
import ReportProductStatistic from "../molecules/report-product-statistic";
import ReportSurveyFinishNot from "../molecules/report-survey-finish-not";
import ReportNewsletter from "../molecules/report-newsletter";

type ReportId =
    | "newUsersAndSurvey"
    | "productStatistic"
    | "surveyFinishedAndNot"
    | "newsletter";

export default function AdminPanel() {
    const profile = useSelector(selectUserProfile);
    const title = profile ? `Cześć ${profile.firstName}!` : "Cześć!";
    const [activeReport, setActiveReport] = useState<ReportId>("newUsersAndSurvey");

    const reportItems = useMemo(
        () => [
            {
                id: "newUsersAndSurvey" as ReportId,
                label: "Nowi użytkownicy i newsletter",
            },
            {
                id: "productStatistic" as ReportId,
                label: "Statystyka kliknięć",
            },
            {
                id: "surveyFinishedAndNot" as ReportId,
                label: "Ankiety ukończone / nieukończone",
            },
            {
                id: "newsletter" as ReportId,
                label: "Newsletter",
            },
        ],
        []
    );

    return (
        <div className={mainGrid}>
           
            <Section columnPhone="full" className={reportsSection}>
                <div className={reportsLayout}>
                    <div className={reportsMenu}>
                        {reportItems.map((item) => {
                            const isActive = activeReport === item.id;
                            return (
                                <button
                                    key={item.id}
                                    type="button"
                                    className={`${reportMenuButton} ${
                                        isActive ? reportMenuButtonActive : ""
                                    }`}
                                    onClick={() => setActiveReport(item.id)}
                                >
                                    {item.label}
                                </button>
                            );
                        })}
                    </div>
                    <div className={reportsContent}>
                        {activeReport === "newUsersAndSurvey" && <ReportNewUserAndSurvey />}
                        {activeReport === "productStatistic" && <ReportProductStatistic />}
                        {activeReport === "surveyFinishedAndNot" && <ReportSurveyFinishNot />}
                        {activeReport === "newsletter" && <ReportNewsletter />}
                    </div>
                </div>
            </Section>
        </div>
    );
}
